//Core Module
import React from "react";

//External Module
import {useDropzone} from 'react-dropzone';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowsDownToLine} from "@fortawesome/free-solid-svg-icons";

const ImportUpload = () => {

    const importNotes = [
        "You can import up to 10000 records per batch",
        "Check box value should beYES or NO.",
        "Date values must be in DD/MM/YYYY format.",
        "Date Time values must be in DD/MM/YYYY hh:mm:ss format.",
        "It is recommended that you test your import with a sample file.",
        "Duplicate record shall be updated on import process.",
        "Assigned To value will be set to login user when given assigned to value is not available in application or import file.",
    ];

    const {getRootProps, getInputProps, open} = useDropzone({
        // Disable click and keydown behavior
        noClick: true,
        noKeyboard: true,
        accept: {
            'text/csv': []
        },
        multiple:false,
        onDrop: (acceptedFiles,rejectedFiles) => {/*processSelectedFiles(acceptedFiles,rejectedFiles)*/},
        onFileDialogCancel:()=>{},
        onFileDialogOpen:()=>{},
        onError:(fileError)=>{}
    });

    return (
        <div className={`import-container`}>
            <div className={`import-container-wrapper`}>
                <div {...getRootProps({className: 'dropzone import-upload-container'})}>
                    <input {...getInputProps()} />
                    <div className={`import-upload-box`}>
                        <span className={`import-upload-title`}>Drag and drop your file here</span>
                        <div className={`import-type-seperator`}>
                            <span>OR</span>
                        </div>
                        <div className={`import-upload-btn-wrapper`}>
                            <le-button onClick={open} className="btn-add header-btn">
                                <button type="button"  className="le-button lePrimaryBtn add-user-btn mR10">
                                    <span className="ux-icon-button">
                                        <span className="double-btn-text" data-ellipsis="true">Upload</span>
                                    </span>
                                </button>
                            </le-button>
                            <le-button className="btn-add header-btn">
                                <button type="button" className="le-button le-defaultBtn add-user-btn mR10">
                                    <span className="ux-icon-button">
                                        <span className="double-btn-text" data-ellipsis="true">Cancel</span>
                                    </span>
                                </button>
                            </le-button>
                        </div>
                        <div className={`import-upload-file-loader`}>

                        </div>
                    </div>
                    <div className={`import-sample-wrapper`}>
                        <a className={`import-sample-download`}>
                            <FontAwesomeIcon className={`import-sample-icon`} icon={faArrowsDownToLine} />
                            Download Sample File
                        </a>
                        <span className={`import-format-desc`}>Supported file format - .csv</span>
                    </div>
                </div>
                <div className={`import-notes-container`}>
                    <span className={`import-notes-title`}>
                        Here’s a handy checklist to ensure a smooth import
                    </span>
                    <ul className={`import-notes-ul`}>
                        {
                            importNotes.map((value)=>{
                                return (
                                    <li className={`import-notes-list`}>
                                        <span className={`import-notes-list-bullet`}></span>
                                        <span className={`import-notes-list-content`}>{value}</span>
                                    </li>
                                )
                            })
                        }
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default ImportUpload;